import {
  TOGGLE_DESCRIPTION_COLLAPSE,
  TOGGLE_DESCRIPTION_EDIT,
  OPEN_DESCRIPTION_EDIT,
  CLOSE_DESCRIPTION_EDIT,
  SET_DESCRIPTION_OBJ,
  SET_DESCRIPTION,
  TOGGLE_RISK,
} from './constants'

import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'

const collapse = createReducer(false, {
  [TOGGLE_DESCRIPTION_COLLAPSE]: (prev) => !prev
})

const edit = createReducer(false, {
  [TOGGLE_DESCRIPTION_EDIT]: (prev) => !prev,
  [OPEN_DESCRIPTION_EDIT]: () => true,
  [CLOSE_DESCRIPTION_EDIT]: () => false,
})

const description = createReducer('', {
  [SET_DESCRIPTION_OBJ]: (prev, { obj }) => obj.description,
  [SET_DESCRIPTION]: (prev, { value }) => value == null ? '' : value,
})

const risk = createReducer(false, {
  [SET_DESCRIPTION_OBJ]: (prev, { obj }) => obj.risk,
  [TOGGLE_RISK]: (prev) => !prev,
})

export default combineReducers({
  collapse,
  edit,
  risk,
  description
})
